export default __webpack_public_path__ + "static/media/plus.5a4eb4c9.png";